import { render, staticRenderFns } from "./ViewTrainerDetails.vue?vue&type=template&id=02b7a4af&"
import script from "./ViewTrainerDetails.vue?vue&type=script&lang=js&"
export * from "./ViewTrainerDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports